import {getApi, postApi, postSysApi} from "./net";
import { messageType, pushSystemMessage } from "./systemMessage.js";

import AskCopyMyListsModal from "../components/AskCopyMyListsModal";
import Logger from "../util/Logger.js";
import {NetworkError} from "../net/httpClient.js";
import PopupNotificationModal from "../components/PopupNotificationModal";
import PopupSeasonModal from "../components/PopupSeasonModal";
import React from "react";
import { createLocalization } from "../util/localization";
import {setCurrentLanguage} from "./userSettings.js";
import {setModal} from "./modal";

export const LOGGING_IN = "LOGGING_IN";
export const LOGGED_IN = "LOGGED_IN";
export const LOGIN_ATTEMPT_ENDED = "LOGIN_ATTEMPT_ENDED";
export const LOGGED_OUT = "LOGGED_OUT";
export const SET_WEBSITE_STATUS_RESULTS = "SET_WEBSITE_STATUS_RESULTS";
export const SET_WEBSITE_MESSAGE_CONFIRMED = "SET_WEBSITE_MESSAGE_CONFIRMED";
export const SET_SEASON_MESSAGE_CONFIRMED = "SET_SEASON_MESSAGE_CONFIRMED";

/**
 * Kontrollerar ifall vi just nu är inloggade.
 * @param {Object} authentication
 * @returns {bool}
 */
export function isLoggedIn(authentication) {
    if (authentication.token == null) {
        return false;
    }

    return authentication.tokenValidUntil >= Date.now();
}

const loggingIn = (loginName, password) => ({
    type: LOGGING_IN,
    loginName,
    password
});

const loggedIn = (payload, languageId, serverName) => ({
    type: LOGGED_IN,
    token: payload.accessToken,
    refreshToken: payload.refreshToken,
    tokenValidUntil: Date.now() + 1000 * 60 * payload.expiresInMinutes,
    signedInAs: payload.userName,
    languageId: languageId,
    serverName: serverName,
    email: payload.email,
    isChainLogin: payload.isChainCustomer,
    isHubLogin: payload.isHubUser,    
    hubId: payload.hubId,
    isDominosLogin: payload.isDominosUser,
    chainType: payload.chainType,
    isAdmin: payload.isAdmin,
    isImpersonated: payload.isImpersonated,
    chainIds: payload.chainIds,
    pickupTobaccoDefault: payload.pickupTobaccoDefault,
    freightChargePickupTobacco: payload.freightChargePickupTobacco,
    isBlockedCustomer : payload.isBlockedCustomer,
    newSeasonDistrDates : payload.newSeasonDistrDates,
    askCopyMyListsUponFirstLogin : payload.askCopyMyListsUponFirstLogin,
    showFreshFood: payload.showFreshFood,
    webEditOnlyTobacco: payload.webEditOnlyTobacco,
});

/**
 * Attempt to log in with a given username and password.
 * @param {string} history
 * @param {string} username
 * @param {string} password
 * @return {Function}
 */
export function logIn(history, username, password) {
    return async (dispatch, getState) => {
        try {
            dispatch(loggingIn(username, password));

            const entirePayload = await dispatch(postSysApi("login", {username,password}));
            if( entirePayload.errorCode===202){
                dispatch( pushSystemMessage(entirePayload.displayMessage, messageType.error) );
            }
            else if( entirePayload.payload ){
                const payload = entirePayload.payload;
                await dispatch(loggedIn(payload, "no", "serverName"));

                if(payload.askCopyMyListsUponFirstLogin)
                {
                    askCopyMylists(dispatch, getState, payload.askCopyMyListsUponFirstLogin);
                }      

                if (payload.webEditOnlyTobacco) {
                    history.replace("/history/tobacco");
                }                
                else if (!payload.isChainCustomer && !payload.isHubUser) {
                    history.replace("/dashboard");
                }
                else if (payload.isHubUser) { // TBD isHubCustomer
                    history.replace("/dominoweb");
                }
                // else if (payload.isDominoUser) { 
                //     history.replace("/dominoweb");
                // }
                else if (payload.isChainCustomer && payload.chainIds && payload.chainIds.length > 1) {
                    history.replace("/chainwebMulti");
                }
                else if (payload.isChainCustomer) {
                    history.replace("/chainwebSingle");
                }
                
                dispatch(setCurrentLanguage("no"));
            } else {
                dispatch( pushSystemMessage("Pålogging mislyktes: Ugyldig brukernavn eller passord", messageType.error) );
            }
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Pålogging mislyktes: Ugyldig brukernavn eller passord", messageType.error));
        } finally {
            dispatch({
                type: LOGIN_ATTEMPT_ENDED,
            });
        }
    };
}

/**
 * Displays message about future order lines
 * @param {Function} dispatch
 * @param {Function} getState
 * @param {string} message
 * @return {undefined}
 */
function askCopyMylists(dispatch, getState, message)
{
    //dispatch(pushSystemMessage("Nye fordelingsordre er nå lagret under fremtidige leveranser. Dine ordre vises i kalenderen", messageType.message));

    dispatch(setModal(
        React.createElement(AskCopyMyListsModal, {
            askQuestion: {message},
            localization: createLocalization(getState()),
            deviceType: getState().view.deviceType,
            width: getState().view.innerWidth,
            copyLists: () => {
                // Close the modal
                dispatch(setModal(null));

                // If the notification is confirmed, confirm it on the server
                dispatch(copyMyListsFromOldWeb());
                
            },
            noAction: () => {
                // Close the modal
                dispatch(setModal(null));
            },
        })
    ));
}


/**
 * Copies my lists fro old web solution
 * @returns {function}
 */
export function copyMyListsFromOldWeb() {
    return async (dispatch) => {
        try {
            await dispatch(postApi("Product/CopyMyListsFromOldWeb"));
        } catch(_) {
            //
        }
    };
}

/**
 * Displays message about future order lines
 * @param {object} localization
 * @param {Function} onCloseModalAndCheck
 * @return {undefined}
 */
export function displaySeasonLinesMessage(localization, onCloseModalAndCheck)
{
    return async (dispatch, getState) => {
        if (!getState().authentication.seasonMessageConfirmed && !getState().modal.modal && localization.localizationData) {
            dispatch(setModal(
                React.createElement(PopupSeasonModal, {
                    notification: {subject: "Nye ordrelinjer", body: "Nye fordelningsordre er nå lagret under fremtidige leveranser. Vennligst se i kalenderen for å se fordelingen!"},
                    localization: localization,
                    deviceType: getState().view.deviceType,
                    width: getState().view.innerWidth,
                    confirm: () => {
                        dispatch({
                            type: SET_SEASON_MESSAGE_CONFIRMED,
                        });
    
                        // Close the modal
                        dispatch(onCloseModalAndCheck());
                    },
                })
            ));
        }        
    };
}

/**
 * Log out the current user.
 * @return {Function}
 */
export function confirmSeasonLineMessage() {
    return dispatch => {
        dispatch({
            type: SET_SEASON_MESSAGE_CONFIRMED,
        });
    };
}

/**
 * Log out the current user.
 * @param {string} history
 * @param {string} reason - Reason for logging out (optional)
 * @return {Function}
 */
export function logOut(history, reason = undefined) {
    return dispatch => {
        dispatch({
            type: LOGGED_OUT,
            reasonForLogOut: reason
        });
        if( history ){
            history.replace(reason ? `/login?ReasonForLogout=${reason}` : "/login");
        }
        location.reload(document.location.reload(true));
    };
}

/**
 * resets the password for a specific user. Will send out an email
 * @param {object} history
 * @param {string} id
 * @return {Function}
 */
export function resetPassword(history, id) {
    return async (dispatch) => {
        try {
            await dispatch(postSysApi("Account/ResetPasswordCommand", {userName:id}));

            dispatch(pushSystemMessage("Det er sendt en e-post med instruksjoner for tilbakestilling av passordet ditt", messageType.message));
            // if( history ){
            //     history.goBack();
            // }
            //location.reload(document.location.reload(true));
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "API Tilbakestill passord mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}
/**
 * Sets a new password for a specific customer. (token is received by email in a link)
 * @param {object} history
 * @param {string} token
 * @param {string} cusNo
 * @param {string} newPassword
 * @return {Function}
 */
export function setNewPassword(history, token, cusNo, newPassword) {
    return async (dispatch) => {
        //const {payload} = await dispatch(postSysApi("ResetPasswordCommand", {userName:cusNo ,email:email}));
        await dispatch(postSysApi("Account/ConfirmEmailCommand", {userName:cusNo ,token:token, password:newPassword}));
        //TODO
        if( history ){
            history.replace("/login");
        }
        location.reload(document.location.reload(true));
    };
}

export const REFRESHING_TOKEN = "REFRESHING_TOKEN";

export const FAILED_TO_REFRESH_TOKEN = "FAILED_TO_REFRESH_TOKEN";

export const REFRESHED_TOKEN = "REFRESHED_TOKEN";

const refreshingToken = () => ({
    type: REFRESHING_TOKEN
});

const failedToRefreshToken = () => ({
    type: FAILED_TO_REFRESH_TOKEN
});

/**
 * Checks that the JWT in the redux store is still valid. If it is valid for less than the specified number of seconds, a new JWT is fetched from the server.
 * If the JWT is invalid, the user is automatically logged out.
 * @param {number} refreshIfValidForLessThanSeconds
 * @param {object} history
 * @return {Function}
 */
export function validateAndRefreshToken(refreshIfValidForLessThanSeconds, history) {
    return async (dispatch, getState) => {
        const {token, refreshToken, tokenValidUntil, refreshing, loggingIn} = getState().authentication;

        if (!token || !tokenValidUntil) {
            dispatch(logOut(history, "Invalid token"));
        } else if ((tokenValidUntil - Date.now()) < 0) {
            dispatch(logOut(history, "Login session expired"));
        } else if (!refreshing && !loggingIn && ((tokenValidUntil - Date.now()) <= (refreshIfValidForLessThanSeconds * 1000))) {
            dispatch(refreshingToken());
            try {
                const {payload} = await dispatch(postSysApi("refresh",{"refreshToken":refreshToken}));
                dispatch({
                    type: REFRESHED_TOKEN,
                    token: payload.accessToken,
                    refreshToken: payload.refreshToken,
                    tokenValidUntil: Date.now() + 1000 * 60 * payload.expiresInMinutes
                });
                //dispatch(setToday(payload.today));
                return payload.accessToken;
            } catch(error) {
                dispatch(failedToRefreshToken());
                if (error.errorType === NetworkError.ErrorType.UNAUTHORIZED) {
                    logOut(history, "Authorization check failed");
                }
                logOut(history, "Failed to refresh token.");
            }
        }

        return token;
    };
}

/**
 * Requests a new JWT which impersonates another user. Only available for administrators. Is eventually followed up by a call
 * to stopImpersonating to go back to being the admin user. Calling this function will simulate a call to logout inbetween
 * which in turn clears out reducer data to default values.
 * 
 * @param {object} history 
 * @param {string} userName 
 * @returns {func}
 */
export function impersonateUser(history, userName) {
    return async (dispatch) => {
        dispatch(loggingIn());
        try {
            const entirePayload = await dispatch(postApi("Account/ImpersonateUserCommand", {
                userName
            }));

            if( entirePayload.payload ){
                const payload = entirePayload.payload;
                dispatch({
                    type: LOGGED_OUT
                });
                dispatch(loggedIn(payload, "no", "serverName"));
                if (payload.webEditOnlyTobacco) {
                    history.replace("/history/tobacco");
                }
                else if (!payload.isChainCustomer) {
                    history.replace("/dashboard");
                }
                else if (payload.isChainCustomer && payload.chainIds && payload.chainIds.length > 1) {
                    history.replace("/chainwebMulti");
                }
                else if (payload.isChainCustomer) {
                    history.replace("/chainwebSingle");
                }
                
                dispatch(setCurrentLanguage("no"));
            } else {
                logOut(history, "Etterligning mislyktes: Ugyldig brukernavn eller rettigheter");
            }
        } catch(error) {
            dispatch(pushSystemMessage(error && error.message || "Etterligning mislyktes", messageType.error));
        }
    };
}

/**
 * Requests a new JWT, which drops an impersonated user and goes back to being the admin user which called the
 * impersonateUser function. Can only be called while impersonating. Calling this function will simulate a call to logout inbetween
 * which in turn clears out reducer data to default values.
 * @param {object} history
 * @returns {func}
 */
export function stopImpersonating(history) {
    return async (dispatch) => {
        dispatch(loggingIn());
        try {
            const entirePayload = await dispatch(postApi("Account/StopImpersonationCommand"));

            if( entirePayload ){
                const payload = entirePayload.payload;
                dispatch({
                    type: LOGGED_OUT
                });
                dispatch(loggedIn(payload, "no", "serverName"));
                if (!payload.isChainCustomer) {
                    history.replace("/dashboard");
                }
                else if (payload.isChainCustomer && payload.chainIds && payload.chainIds.length > 1) {
                    history.replace("/chainwebMulti");
                }
                else if (payload.isChainCustomer) {
                    history.replace("/chainwebSingle");
                }
                
                dispatch(setCurrentLanguage("no"));
            } else {
                logOut(history, "Etterligning mislyktes: Ugyldige rettigheter.");
            }
        } catch(error) {
            dispatch(pushSystemMessage(error && error.message || "Etterligning mislyktes", messageType.error));
        }
    };
}


/**
 * Get web site status
 * @returns {func}
 */
export function getWebSiteStatus(){
    return async (dispatch) => {
        try {

            const {payload} = await dispatch(getApi("Account/WebSiteStatusQuery"));

            // Store query results
            await dispatch({
                type: SET_WEBSITE_STATUS_RESULTS,
                webIsClosed: payload.webIsClosed,
                message: payload.message,
            });

        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Kontroll av web site status mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Checks if web site is closed for maintenance displays warning popup 
 * @return {function}
 */
export function checkIfWebSiteIsClosed() {
    return async (dispatch, getState) => {
        const loading = dispatch(getWebSiteStatus());
        await loading;
        const { webSiteClosed, webSiteClosedMessage, userConfirmedWebSiteClosedMessage } = getState().authentication;

        if (webSiteClosed && webSiteClosedMessage !== "" && !userConfirmedWebSiteClosedMessage && !getState().modal.modal) {
            // There is no active modal and we have at least one unread popup notification. Create a modal.
            dispatch(setModal(
                React.createElement(PopupNotificationModal, {
                    notification: {subject: "Kundeweb stenges for vedlikehold", body: webSiteClosedMessage},
                    localization: createLocalization(getState()),
                    deviceType: getState().view.deviceType,
                    width: getState().view.innerWidth,
                    confirm: () => {
                        // Set status to avoid further pop ups    
                        dispatch({
                            type: SET_WEBSITE_MESSAGE_CONFIRMED,
                        });

                        // Close the modal
                        dispatch(setModal(null));
                    },
                    remindLater: (dismissModal) => {
                        if (dismissModal) {
                            dispatch(setModal(null));
                        }
                    }
                })
            ));
        }
    };
}